import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useLocation } from "@tanstack/react-router";
import { scrollToElement } from "../../lib/motion";

interface FooterProps {
  scrollToContact: () => void;
}

const Footer: React.FC<FooterProps> = ({ scrollToContact }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleConsult = () => {
    if (location.pathname === "/") {
      const el = document.getElementById("book-consult");
      if (el) {
        scrollToContact();
        scrollToElement("#book-consult");
        return;
      }
    }
    navigate({ to: "/packages", hash: "consult" });
  };

  return (
    <footer id="footer_cont" role="contentinfo">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <nav aria-label="Footer navigation">
              <ul>
                <li>
                  <a href="/" className="nav-link">
                    About
                  </a>
                </li>
                <li>
                  <a href="/projects" className="nav-link">
                    Featured Works
                  </a>
                </li>
                <li>
                  <a href="/packages" className="nav-link">
                    Packages
                  </a>
                </li>
                <li>
                  <a href="/articles" className="nav-link">
                    Articles
                  </a>
                </li>
                <li>
                  <a href="/play" className="nav-link">
                    Play the game
                  </a>
                </li>
                <li>
                  <button
                    type="button"
                    className="nav-link bg-transparent border-0 cursor-pointer"
                    onClick={handleConsult}
                  >
                    Book a consult
                  </button>
                </li>
                <li className="nav-item">
                  <a
                    href="https://drive.google.com/file/d/1pXw_RS_-uMIqETQ84OGuNk991pyJPBMa/view?usp=sharing"
                    download=""
                    target="_blank"
                    rel="noopener noreferrer"
                    className="nav-link"
                    aria-label="Download resume (opens in new tab)"
                  >
                    <FontAwesomeIcon icon={faFilePdf} aria-hidden="true" />
                    <span className="ms-1">Resume</span>
                  </a>
                </li>
              </ul>
            </nav>
              <div className="justify-center mt-2 mb-2 md:flex hidden">
                <small className="text-center flex gap-2 items-center">
                  <span className="text-white">Don Benary Lagadan</span>
                  <span>|</span>
                  <a href="tel:+639174211608" className="text-white">
                    +63 9174211608
                  </a>
                  <span>|</span>
                  <a className="text-white" href="mailto:donbenaryl@gmail.com">
                    donbenaryl@gmail.com
                  </a>
                </small>
              </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
